import axios from 'axios'
export default {
  getMessage (field, args) {
    return field
  },
  validate (value) {
    return new Promise(resolve => {
      axios.get('https://open.kickbox.com/v1/disposable/' + value)
        .then((res) => {
          // console.log(res)
          resolve({
            valid: !res.data.disposable
          })
        }).catch(error => {
          console.log(error)
        })
    })
  }
}
